import { render, staticRenderFns } from "./app-event-info.vue?vue&type=template&id=55dc4af1&"
import script from "./app-event-info.vue?vue&type=script&lang=js&"
export * from "./app-event-info.vue?vue&type=script&lang=js&"
import style0 from "./app-event-info.vue?vue&type=style&index=0&id=55dc4af1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports